export default __webpack_public_path__ + "assets/images/27d8a7abd3bc719c3abeeadc712ee2bd.png";